var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M9.66699 6.16797V9.5013L10.917 10.7513",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2087",
    d: "M15.9555 13.2111C17.3192 13.9475 18.001 14.3157 18.001 14.9167C18.001 15.5176 17.3192 15.8858 15.9555 16.6222L15.0269 17.1236C13.9797 17.6892 13.456 17.972 13.2043 17.7664C12.5876 17.2629 13.5483 15.9634 13.7846 15.5031C14.0241 15.0366 14.0197 14.7882 13.7846 14.3302C13.5483 13.8699 12.5876 12.5705 13.2043 12.067C13.456 11.8614 13.9797 12.1442 15.0269 12.7097L15.9555 13.2111Z",
    stroke: "#3D3D3D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5224 17.7913C10.2413 17.82 9.95601 17.8346 9.66732 17.8346C5.06494 17.8346 1.33398 14.1037 1.33398 9.5013C1.33398 4.89893 5.06494 1.16797 9.66732 1.16797C14.2697 1.16797 18.0007 4.89893 18.0007 9.5013C18.0007 10.0721 17.9433 10.6295 17.834 11.168",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.3d718e49849702eea1b4b1fc8f603d90.svg";
export { ForwardRef as ReactComponent };